import { Component, OnInit, OnDestroy } from '@angular/core';
import { PensionDataService } from './../services/pension-data.service';

import { Subscription } from 'rxjs';
import { IPension } from './../models/pension.model';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormTemplateGridService } from './../services/form-template-grid.service';

import { ZenplansTestDataProviderService } from './../services/zenplans-test-data-provider.service';
import { IDataGrid } from './../models/data-grid.model';
//import pensionsData from '../../assets/data/seed/pensions.json';
import { DialogResultService } from './../services/dialog-result.service';
import { ItemDataService } from './../services/item-data.service';


@Component({
  selector: 'app-dynamic-grid',
  templateUrl: './dynamic-grid.component.html',
  styleUrls: ['./dynamic-grid.component.scss']
})

export class DynamicGridComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  templateName: string; newPension: IPension;
  newItem; Id; action;
  editItem; myFormTemplate: IDataGrid; myTemplateParam;
  pensions; itemList; myItemList;
  myItemList2; itemName; myPensions: IPension[];
  reviewStatus; deleteId; showDialog = false;
  localData; sectionTitle;
  visible = false; myResult;
  itemToDeleteId;
  itemNameforDialog;
  noItems = false;
  noItemsPre = false;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router, private formTemplateGridService: FormTemplateGridService,
    private zenplansDataService: ZenplansTestDataProviderService) {
    this.activatedRoute.paramMap.subscribe(params => {
      this.templateName = params.get('templateName');
      this.action = params.get('action');
    });
    var kkk = 0;
  }

  async ngOnInit() {
    this.sectionTitle = await this.fillFormTemplateInfo(this.templateName);

    this.subscription = await this.zenplansDataService.currentMessage.subscribe(message => {
      var mySectionTitle;
      this.zenplansDataService.getSection(this.myFormTemplate.sectionTitle).
        then(kk => {
          if (kk) {
            this.itemList = kk;
            this.myItemList = this.itemList;
            this.myItemList2 = this.itemList;

            let now = new Date();

            this.myItemList.map(kk => {
              //kk.lastUpdate = new Date(kk.lastUpdate); //new Date(kk.lastUpdate).toDateString();
              //kk.myLastUpdate = JSON.parse(kk.lastUpdate);
              //kk.lastUpdate = JSON.parse(kk.lastUpdate); // new Date(JSON.parse(kk.lastUpdate)); //new Date(kk.lastUpdate).toDateString();
              var timeToReview = true;
              if (kk.upToDateExpire) {
                let myExpire = new Date(kk.upToDateExpire);
                timeToReview = (myExpire < now);
              }
              kk.status = timeToReview ? "time to review" : "up to date";
              if (!kk.lastUpdateBy) { kk.lastUpdateBy = "Sam"; }
            });

          }
          this.noItems = (this.itemList.length == 0 && this.myFormTemplate.sectionTitle !="delegates");
          this.noItemsPre = this.noItems;
        });
    });
  }

  async fillFormTemplateInfo(templateName: string) {
    await this.formTemplateGridService.getFormTemplateAsync(templateName).then(kk => {
      this.myFormTemplate = kk;
      let mySectionTitle = kk.sectionTitle;
      return mySectionTitle;
    });

  }
  //route to first page of the "steps" of a new item
  add(url: string) {
    this.router.navigate(['/' + url]);
  }

  //have a look at a item
  view(id: string) {
    this.router.navigate(['/' + this.myFormTemplate.viewUrl + "/" + id]);
  }

  //edit a item`
  edit(id: string) {
    this.router.navigate(['/' + this.myFormTemplate.editUrl + "/" + id]);
  }

  deleteByEvent(choice) {
    if (choice === 'Yes') {
      this.zenplansDataService.deleteItem(this.itemToDeleteId, this.myFormTemplate.sectionTitle);
    }
    this.showDialog = !this.showDialog;
  }

  async callDialog(id, name) {
    this.itemToDeleteId = id;
    this.itemNameforDialog = name;
    this.showDialog = !this.showDialog;
  }
  changeNoItemPre() {
    this.noItemsPre = false;
  }
  goHome() {
    this.router.navigate(['/home']);
  }

  ngOnDestroy() {
    if(this.subscription){
    this.subscription.unsubscribe();
    }
  }
}